export * from './IconFlagStroked';
